(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2150,5442,3154],{

/***/ 9695:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[mobileOrDesktop]/[hostname]/order",
      function () {
        return __webpack_require__(29968);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 93154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* binding */ AddressForm; },
  "Z": function() { return /* binding */ CreateAddress; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.esm.js
var react_select_esm = __webpack_require__(23157);
// EXTERNAL MODULE: ./src/components/Button/index.tsx
var Button = __webpack_require__(40076);
// EXTERNAL MODULE: ./src/components/ClientSuspense/index.tsx
var ClientSuspense = __webpack_require__(88385);
// EXTERNAL MODULE: ./src/components/fields/DeliveryType/index.tsx
var DeliveryType = __webpack_require__(35438);
// EXTERNAL MODULE: ./src/components/Loading/index.tsx
var Loading = __webpack_require__(69528);
// EXTERNAL MODULE: ./src/components/Modal/index.tsx + 1 modules
var Modal = __webpack_require__(38855);
// EXTERNAL MODULE: ./src/helpers/addresses/AddressesContext.ts
var AddressesContext = __webpack_require__(301);
// EXTERNAL MODULE: ./src/helpers/addresses/models.ts
var models = __webpack_require__(88315);
// EXTERNAL MODULE: ./src/helpers/misc/isServerSide.ts
var isServerSide = __webpack_require__(90257);
// EXTERNAL MODULE: ./src/helpers/posthog/index.ts
var posthog = __webpack_require__(53023);
// EXTERNAL MODULE: ./src/hooks/useCountryCode.ts
var useCountryCode = __webpack_require__(50900);
// EXTERNAL MODULE: ./src/hooks/useMessage.ts
var useMessage = __webpack_require__(5528);
// EXTERNAL MODULE: ./src/hooks/useShouldRequireCity.ts
var useShouldRequireCity = __webpack_require__(13344);
// EXTERNAL MODULE: ./src/hooks/useWebsiteId.ts
var useWebsiteId = __webpack_require__(16825);
// EXTERNAL MODULE: ./node_modules/@packages/apollo-hooks/lib/useApolloQuery.js
var useApolloQuery = __webpack_require__(28613);
var useApolloQuery_default = /*#__PURE__*/__webpack_require__.n(useApolloQuery);
// EXTERNAL MODULE: ./src/page-components/Checkout/Checkout/Delivery/Address/AddressOutOfBounds/useAddressOutOfBounds.ts
var useAddressOutOfBounds = __webpack_require__(40332);
// EXTERNAL MODULE: ./src/page-components/Checkout/Checkout/Delivery/Address/Update/CitySelector/index.tsx + 1 modules
var CitySelector = __webpack_require__(89431);
// EXTERNAL MODULE: ./src/page-components/Checkout/Checkout/Delivery/Address/Update/OutOfBoundsAlert/index.tsx
var OutOfBoundsAlert = __webpack_require__(55888);
// EXTERNAL MODULE: ./src/page-components/Checkout/Checkout/Delivery/Address/Update/SelectedStore/index.tsx + 1 modules
var SelectedStore = __webpack_require__(47598);
// EXTERNAL MODULE: ./src/page-components/Checkout/Checkout/Delivery/StoreName/index.tsx
var StoreName = __webpack_require__(59450);
// EXTERNAL MODULE: ./src/page-components/Order/Options/UpdateBasicOptions/StoreMessage/index.tsx
var StoreMessage = __webpack_require__(13467);
// EXTERNAL MODULE: ./src/page-components/Order/Options/UpdateBasicOptions/TableName/index.tsx + 1 modules
var TableName = __webpack_require__(99590);
// EXTERNAL MODULE: ./src/page-components/Order/Options/UpdateBasicOptions/Time/index.tsx
var Time = __webpack_require__(84339);
// EXTERNAL MODULE: ./src/providers/Addresses/queries.ts
var queries = __webpack_require__(81601);
;// CONCATENATED MODULE: ./src/providers/Addresses/hooks/useOrderOptionPreferences.ts



function useOrderOptionPreferences() {
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var ref = useApolloQuery_default()({
        query: queries/* getPreferencesQuery */.x3,
        variables: {
            websiteId: websiteId
        },
        partial: true
    }), data = ref.data, loading = ref.loading, error = ref.error;
    return {
        data: data,
        loading: loading,
        error: error
    };
};

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@apollo/client/node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(76661);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
;// CONCATENATED MODULE: ./src/providers/Addresses/hooks/useUpdateDeliveryType.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  mutation setPreferencesAddressProviderHook($websiteId: ID, $deliveryType: ID) {\n    setUserPreferences(websiteId: $websiteId, deliveryType: $deliveryType) {\n      _id\n      deliveryType\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var setDeliveryTypeMutation = (0,lib/* gql */.Ps)(_templateObject());
function useUpdateDeliveryType(param) {
    var onSuccess = param.onSuccess, onError = param.onError;
    var ref2;
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var ref1 = _slicedToArray((0,useMutation/* useMutation */.D)(setDeliveryTypeMutation), 1), updateDeliveryTypeHook = ref1[0];
    var data = useOrderOptionPreferences().data;
    var updateDeliveryType = (0,react.useCallback)(function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(deliveryType) {
            var ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        _ctx.next = 4;
                        return updateDeliveryTypeHook({
                            variables: {
                                deliveryType: deliveryType,
                                websiteId: websiteId
                            },
                            optimisticResponse: {
                                __typename: "Mutation",
                                setUserPreferences: {
                                    __typename: "Preference",
                                    _id: data === null || data === void 0 ? void 0 : (ref = data.preferences) === null || ref === void 0 ? void 0 : ref._id,
                                    deliveryType: deliveryType
                                }
                            }
                        });
                    case 4:
                        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                        _ctx.next = 10;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        onError === null || onError === void 0 ? void 0 : onError(_ctx.t0);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function(deliveryType) {
            return _ref.apply(this, arguments);
        };
    }(), [
        data === null || data === void 0 ? void 0 : (ref2 = data.preferences) === null || ref2 === void 0 ? void 0 : ref2._id,
        onError,
        onSuccess,
        updateDeliveryTypeHook,
        websiteId
    ]);
    return updateDeliveryType;
};

;// CONCATENATED MODULE: ./src/providers/Addresses/hooks/useUpdateStoreId.ts
function useUpdateStoreId_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useUpdateStoreId_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function useUpdateStoreId_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useUpdateStoreId_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useUpdateStoreId_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useUpdateStoreId_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function useUpdateStoreId_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function useUpdateStoreId_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useUpdateStoreId_slicedToArray(arr, i) {
    return useUpdateStoreId_arrayWithHoles(arr) || useUpdateStoreId_iterableToArrayLimit(arr, i) || useUpdateStoreId_unsupportedIterableToArray(arr, i) || useUpdateStoreId_nonIterableRest();
}
function useUpdateStoreId_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function useUpdateStoreId_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useUpdateStoreId_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useUpdateStoreId_arrayLikeToArray(o, minLen);
}

function useUpdateStoreId_templateObject() {
    var data = useUpdateStoreId_taggedTemplateLiteral([
        "\n  mutation setUserStoreIdPreferencesAddressProviderHook($websiteId: ID, $storeId: ID) {\n    setUserPreferences(websiteId: $websiteId, storeId: $storeId) {\n      _id\n      storeId\n      store {\n        _id\n        name\n        schedule {\n          itsOpenNow: itsAvailableAt\n        }\n        acceptServeSchedulingOrders\n        schedulingOrdersDays\n        currentPreparationDuration\n        currentExtraDeliveryCost\n        currentDeliveryDuration\n        isOverloaded\n        address {\n          address\n          placeId\n          addressLine2\n          location\n        }\n      }\n    }\n  }\n"
    ]);
    useUpdateStoreId_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var setStoreIdMutation = (0,lib/* gql */.Ps)(useUpdateStoreId_templateObject());
function useUpdateStoreId(param) {
    var onSuccess = param.onSuccess, onError = param.onError;
    var ref;
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var ref1 = useUpdateStoreId_slicedToArray((0,useMutation/* useMutation */.D)(setStoreIdMutation), 1), updateStoreIdHook = ref1[0];
    var data = useOrderOptionPreferences().data;
    var updateStoreId = (0,react.useCallback)(function() {
        var _ref = useUpdateStoreId_asyncToGenerator(runtime_default().mark(function _callee(storeId) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return updateStoreIdHook({
                            variables: {
                                storeId: storeId,
                                websiteId: websiteId
                            },
                            refetchQueries: [
                                "getMyOrderPreferences"
                            ]
                        });
                    case 3:
                        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                        _ctx.next = 9;
                        break;
                    case 6:
                        _ctx.prev = 6;
                        _ctx.t0 = _ctx["catch"](0);
                        onError === null || onError === void 0 ? void 0 : onError(_ctx.t0);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    6
                ]
            ]);
        }));
        return function(storeId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        data === null || data === void 0 ? void 0 : (ref = data.preferences) === null || ref === void 0 ? void 0 : ref._id,
        onError,
        onSuccess,
        updateStoreIdHook,
        websiteId
    ]);
    return updateStoreId;
};

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 37 modules
var esm = __webpack_require__(12284);
;// CONCATENATED MODULE: ./src/components/Address/AddressSearchSelector/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







function AddressSearchSelector(param1) {
    var valueProps = param1.value, onChangeProps = param1.onChange, setPlaceId = param1.passProps.setPlaceId, isModal = param1.isModal;
    var ref = (0,react.useContext)(AddressesContext/* default */.Z), options = ref.options, filter = ref.filter, setFilter = ref.setFilter, isLoadingOptions = ref.isLoadingOptions, loadingGeolocation = ref.loadingGeolocation, clear = ref.clear, sessionId = ref.sessionId, placeId = ref.placeId;
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "order.options.updateBasicOptions"
    }).t;
    var value = (0,react.useMemo)(function() {
        if (!valueProps) return null;
        var firstElement = Array.isArray(options) && options.length ? options[0] : null;
        var selectedElement = options.find(function(option) {
            return option.value === valueProps;
        });
        return selectedElement !== null && selectedElement !== void 0 ? selectedElement : firstElement;
    }, [
        options,
        valueProps
    ]);
    var onChange = (0,react.useCallback)(function(option, actionMeta) {
        if (actionMeta.action === "select-option") {
            (0,posthog.sendPosthogData)(posthog.EVENTS.selected.addressOption, {
                placeId: option.value,
                filter: filter,
                sessionId: sessionId,
                previousPlaceId: placeId
            });
            // onChange calls setPlaceId
            onChangeProps(option.value);
        } else if (actionMeta.action === "clear" || actionMeta.action === "deselect-option") {
            clear(models/* ClearType.PLACE_ID */.Nl.PLACE_ID);
        }
    }, [
        clear,
        filter,
        onChangeProps,
        placeId,
        sessionId,
        setPlaceId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_esm["default"], {
        styles: {
            menu: function(provided) {
                return _objectSpread({}, provided, {
                    zIndex: 1001
                });
            },
            input: function(provided, state) {
                var color = provided.color, styles = _objectWithoutProperties(provided, [
                    "color"
                ]);
                return _objectSpread({}, styles);
            }
        },
        classNamePrefix: "orion-select",
        placeholder: t("address.placeholder"),
        options: options,
        isClearable: true,
        inputValue: filter !== null && filter !== void 0 ? filter : "",
        onInputChange: setFilter,
        isLoading: isLoadingOptions || loadingGeolocation,
        noOptionsMessage: function(param) {
            var inputValue = param.inputValue;
            return inputValue ? "No hemos podido encontrar tu direcci\xf3n. Puedes usar una ubicaci\xf3n de referencia y luego corregir la posici\xf3n en el mapa" : "Escribe tu direcci\xf3n con calle y n\xfamero para que aparezcan los resultados";
        },
        value: value,
        onChange: onChange,
        filterOption: null
    }, "loaded");
};

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/Address/LeafletMap/index.tsx

// es importante cargarlo así por que Leaflet no funciona correctamente con ssr.
var Map = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9269), __webpack_require__.e(127), __webpack_require__.e(7194)]).then(__webpack_require__.bind(__webpack_require__, 68764));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68764)
            ];
        }
    },
    ssr: false
});
/* harmony default export */ var LeafletMap = (Map);

// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/fields/Text/index.js
var Text = __webpack_require__(55672);
// EXTERNAL MODULE: ./src/components/Address/SecondLineInput/styles.module.css
var styles_module = __webpack_require__(29344);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/Address/SecondLineInput/index.tsx





function SecondLineInput(param) {
    var value = param.value, onChange = param.onChange;
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "order.options.updateBasicOptions"
    }).t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                className: "os-input-text",
                placeholder: t("addressLine2.placeholder"),
                value: value !== null && value !== void 0 ? value : "",
                onChange: onChange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).example_label,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: t("addressLine2.example")
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/Tooltip/index.js
var Tooltip = __webpack_require__(34053);
// EXTERNAL MODULE: ./src/components/Address/styles.module.css
var Address_styles_module = __webpack_require__(65035);
var Address_styles_module_default = /*#__PURE__*/__webpack_require__.n(Address_styles_module);
;// CONCATENATED MODULE: ./src/components/Address/SubmitButton.tsx




var ConditionalWrapper = function(param) {
    var condition = param.condition, wrapper = param.wrapper, children = param.children;
    return condition ? wrapper(children) : children;
};
function SubmitButton(param) {
    var disabled = param.disabled, onClick = param.onClick, message = param.message;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalWrapper, {
        condition: disabled,
        wrapper: function(children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip["default"], {
                className: (Address_styles_module_default()).tooltip,
                content: "Completa todos los campos para continuar",
                children: children
            });
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Address_styles_module_default()).formSubmitButton,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                primary: true,
                disabled: disabled,
                fullWidth: true,
                onClick: onClick,
                children: message
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Address/index.tsx
function Address_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Address_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Address_defineProperty(target, key, source[key]);
        });
    }
    return target;
}






































var MOBILE_WIDTH_THRESHOLD = 650;
var ADDRESS_COUNTRIES = [
    "CL",
    "PE",
    "CO"
];
var MapPosition;
(function(MapPosition) {
    MapPosition["TOP"] = "TOP";
    MapPosition["BOTTOM"] = "BOTTOM";
})(MapPosition || (MapPosition = {}));
var AddressForm = function(param) {
    var typeSuggestion = param.type, isModal = param.isModal, websiteId = param.websiteId, closeModal = param.closeModal, onSelectDeliveryType = param.onSelectDeliveryType, showStoreName = param.showStoreName;
    var handleLocation = function handleLocation(position) {
        var lat = position.coords.latitude;
        var lng = position.coords.longitude;
        setLocation({
            lat: lat,
            lng: lng
        });
        setLoadingGeolocation(false);
    };
    var errorHandler = function errorHandler(err) {
        setLoadingGeolocation(false);
        if (err.code == 1) {
            (0,posthog.sendPosthogData)(posthog.EVENTS.error.locationAccessDenied, {
                sessionId: sessionId
            });
            showMessage(new Error(t("geolocation.errors.accessDenied")));
        } else if (err.code == 2) {
            (0,posthog.sendPosthogData)(posthog.EVENTS.error.locationUnavailable, {
                sessionId: sessionId
            });
            showMessage(new Error(t("geolocation.errors.unavailable")));
        }
    };
    var getLocation = function getLocation() {
        (0,posthog.sendPosthogData)(posthog.EVENTS.clicked.useLocation, {
            sessionId: sessionId
        });
        setLoadingGeolocation(true);
        if (navigator.geolocation) {
            // timeout at 60000 milliseconds (60 seconds)
            var options = {
                timeout: 60000,
                // This forces the device to give better results IF IT CAN, but it can take longer or consume more battery.
                enableHighAccuracy: true,
                // To prevent the use of cached locations
                maximumAge: 0
            };
            navigator.geolocation.getCurrentPosition(handleLocation, errorHandler, options);
        } else {
            setLoadingGeolocation(false);
            showMessage(new Error("Lo sentimos, tu navegador no soporta geolocalizaci\xf3n"));
        }
    };
    var ref10, ref1, ref2;
    var ref3 = (0,react.useContext)(AddressesContext/* default */.Z), placeId = ref3.placeId, setPlaceId = ref3.setPlaceId, selectedCity = ref3.selectedCity, setSelectedCity = ref3.setSelectedCity, location1 = ref3.location, setLocation = ref3.setLocation, clear = ref3.clear, addressLine2 = ref3.addressLine2, setAddressLine2 = ref3.setAddressLine2, loadingGeolocation = ref3.loadingGeolocation, setLoadingGeolocation = ref3.setLoadingGeolocation, sessionId = ref3.sessionId;
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "order.options.updateBasicOptions"
    }).t;
    var countryCode = (0,useCountryCode/* default */.Z)();
    var showMessage = (0,useMessage/* default */.Z)();
    var ref4 = (0,react.useState)(true), showSubmitButton = ref4[0], setShowSubmitButton = ref4[1];
    var ref5 = useOrderOptionPreferences(), orderPreferencesData = ref5.data, loading = ref5.loading;
    var deliveryType = orderPreferencesData === null || orderPreferencesData === void 0 ? void 0 : (ref10 = orderPreferencesData.preferences) === null || ref10 === void 0 ? void 0 : ref10.deliveryType;
    var updateDeliveryType = useUpdateDeliveryType({});
    var storeId = orderPreferencesData === null || orderPreferencesData === void 0 ? void 0 : (ref1 = orderPreferencesData.preferences) === null || ref1 === void 0 ? void 0 : ref1.storeId;
    var updateStoreId = useUpdateStoreId({});
    var ref6 = useApolloQuery_default()({
        query: queries/* getWebsiteStoresQuery */.qj,
        variables: {
            websiteId: websiteId
        }
    }), queryStores = ref6.stores;
    var ref7 = useApolloQuery_default()({
        query: queries/* getMyOrderPreferencesQuery */.E2,
        variables: {
            websiteId: websiteId,
            storeId: storeId
        },
        omit: (0,isServerSide/* default */.Z)() || !websiteId,
        partial: true
    }), queryPreferences = ref7.preferences;
    var ref8;
    var stores = (ref8 = queryStores === null || queryStores === void 0 ? void 0 : queryStores.items) !== null && ref8 !== void 0 ? ref8 : [];
    var store1 = stores.find(function(store) {
        return store.value === storeId;
    });
    var preferences = queryPreferences !== null && queryPreferences !== void 0 ? queryPreferences : {};
    var isAddressCountry = ADDRESS_COUNTRIES.includes(countryCode.toUpperCase());
    var mapPosition = isAddressCountry ? MapPosition.BOTTOM : MapPosition.TOP;
    var containerRef = (0,react.useRef)(null);
    var ref9 = (0,react.useState)(0), width = ref9[0], setWidth = ref9[1];
    var handleWindowSizeChange = function() {
        if (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) setWidth(containerRef.current.offsetWidth);
    };
    (0,react.useEffect)(function() {
        handleWindowSizeChange();
        window.addEventListener("resize", handleWindowSizeChange);
        return function() {
            window.removeEventListener("resize", handleWindowSizeChange);
        };
    }, []);
    var displayOutOfBoundsMsg = (0,useAddressOutOfBounds/* default */.Z)({
        placeId: placeId,
        storeId: storeId
    });
    var type = typeSuggestion;
    if (typeSuggestion === models/* AddressFormType.FormAndMap */.tv.FormAndMap && width < MOBILE_WIDTH_THRESHOLD || typeSuggestion === models/* AddressFormType.Form */.tv.Form) {
        if (mapPosition === MapPosition.TOP) type = models/* AddressFormType.FormWithTopMap */.tv.FormWithTopMap;
        if (mapPosition === MapPosition.BOTTOM) type = models/* AddressFormType.FormWithBottomMap */.tv.FormWithBottomMap;
    }
    var shouldRequireCity = (0,useShouldRequireCity/* default */.Z)();
    var shouldShowTitle = type !== models/* AddressFormType.DeliveryTypes */.tv.DeliveryTypes;
    var shouldShowMap = deliveryType === models/* DeliveryTypes.DELIVERY */.TB.DELIVERY && placeId || deliveryType !== models/* DeliveryTypes.DELIVERY */.TB.DELIVERY && storeId;
    var shouldShowSideMap = shouldShowMap && type === models/* AddressFormType.FormAndMap */.tv.FormAndMap;
    var shouldShowHighMap = shouldShowMap && type === models/* AddressFormType.FormWithTopMap */.tv.FormWithTopMap;
    var shouldShowLowMap = shouldShowMap && type === models/* AddressFormType.FormWithBottomMap */.tv.FormWithBottomMap;
    var shouldShowForm = shouldShowTitle;
    var mapLocation = deliveryType === models/* DeliveryTypes.DELIVERY */.TB.DELIVERY ? location1 : store1 === null || store1 === void 0 ? void 0 : (ref2 = store1.address) === null || ref2 === void 0 ? void 0 : ref2.location;
    var isDraggingMarkerEnabled = deliveryType === models/* DeliveryTypes.DELIVERY */.TB.DELIVERY;
    var isSubmitDisabled = deliveryType === models/* DeliveryTypes.DELIVERY */.TB.DELIVERY ? !placeId : !storeId;
    var formMap = (0,react.useMemo)(function() {
        return (shouldShowHighMap || shouldShowLowMap) && mapLocation && /*#__PURE__*/ (0,jsx_runtime.jsx)(LeafletMap, {
            location: mapLocation,
            isDraggingMarkerEnabled: isDraggingMarkerEnabled,
            setLocation: function(location) {
                setShowSubmitButton(true);
                setLocation(location);
            },
            containerClass: classnames_default()((Address_styles_module_default()).embeddedMapContainer, Address_defineProperty({}, (Address_styles_module_default()).embeddedMapContainerThin, width < MOBILE_WIDTH_THRESHOLD && typeSuggestion !== models/* AddressFormType.FormAndMap */.tv.FormAndMap))
        });
    }, [
        isDraggingMarkerEnabled,
        mapLocation,
        setLocation,
        shouldShowHighMap,
        shouldShowLowMap,
        typeSuggestion,
        width
    ]);
    var sideMap = (0,react.useMemo)(function() {
        return shouldShowSideMap && mapLocation && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Address_styles_module_default()).mapSection,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LeafletMap, {
                location: mapLocation,
                isDraggingMarkerEnabled: isDraggingMarkerEnabled,
                setLocation: function(location) {
                    setShowSubmitButton(true);
                    setLocation(location);
                }
            })
        });
    }, [
        isDraggingMarkerEnabled,
        mapLocation,
        setLocation,
        shouldShowSideMap
    ]);
    var renderStore = function() {
        if (!deliveryType) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreMessage/* default */.Z, {
                preferences: preferences
            });
        }
        if (!preferences || loading) return;
        var filteredStores = stores === null || stores === void 0 ? void 0 : stores.filter(function(store) {
            var ref;
            if (!(store === null || store === void 0 ? void 0 : (ref = store.address) === null || ref === void 0 ? void 0 : ref.placeId)) {
                return false;
            }
            if (deliveryType === models/* DeliveryTypes.GO */.TB.GO && store.acceptGo) {
                return true;
            }
            if (deliveryType === models/* DeliveryTypes.SERVE */.TB.SERVE && store.acceptServe) {
                return true;
            }
            return false;
        });
        var hasOptions = filteredStores === null || filteredStores === void 0 ? void 0 : filteredStores.length;
        if (!hasOptions) {
            updateStoreId(null);
        }
        var isStoreIdIncludedInOptions = filteredStores === null || filteredStores === void 0 ? void 0 : filteredStores.map(function(option) {
            return option.value;
        }).includes(storeId);
        if (hasOptions && !storeId || hasOptions && storeId && !isStoreIdIncludedInOptions) {
            updateStoreId(filteredStores[0].value);
        }
        var value = filteredStores.find(function(store) {
            return store.value === storeId;
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                shouldShowHighMap && deliveryType !== models/* DeliveryTypes.DELIVERY */.TB.DELIVERY && formMap,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "label",
                    style: {
                        marginTop: 0
                    },
                    children: t("labelChooseStore")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_esm["default"], {
                    value: value,
                    onChange: function(option) {
                        setShowSubmitButton(true);
                        updateStoreId(option.value);
                    },
                    classNamePrefix: "orion-select",
                    placeholder: t("labelSelectStore"),
                    options: filteredStores,
                    filterOption: null,
                    menuPosition: isModal ? "fixed" : undefined,
                    styles: Address_objectSpread({
                        control: function(provided) {
                            return Address_objectSpread({}, provided, {
                                padding: "4px 0"
                            });
                        }
                    }, isModal ? {
                        menuPortal: function(provided) {
                            return Address_objectSpread({}, provided, {
                                zIndex: 1001
                            });
                        }
                    } : {
                        menu: function(provided) {
                            return Address_objectSpread({}, provided, {
                                zIndex: 1001
                            });
                        }
                    })
                })
            ]
        }, "storeSelector".concat(deliveryType));
    };
    var renderTime = function() {
        var time = preferences.time;
        if (!store1) return;
        if (deliveryType === models/* DeliveryTypes.SERVE */.TB.SERVE && !store1.acceptServeSchedulingOrders) return;
        if (deliveryType === models/* DeliveryTypes.SERVE */.TB.SERVE && time === "now") return;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Time/* default */.Z, {
                    selectorProps: {
                        menuPosition: "fixed",
                        styles: {
                            menuPortal: function(provided) {
                                return Address_objectSpread({}, provided, {
                                    zIndex: 1001
                                });
                            }
                        }
                    },
                    onChange: function() {
                        return setShowSubmitButton(true);
                    },
                    preferences: preferences,
                    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
                    showDirections: !!placeId && placeId !== "no-deliver"
                }),
                shouldShowLowMap && deliveryType !== models/* DeliveryTypes.DELIVERY */.TB.DELIVERY && formMap
            ]
        });
    };
    var renderTableName = function() {
        var time = preferences.time;
        if (!store1) return;
        if (deliveryType !== models/* DeliveryTypes.SERVE */.TB.SERVE) return;
        if (time !== "now") return;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableName/* default */.Z, {
            preferences: preferences
        });
    };
    var renderDelivery = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: shouldShowForm && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Address_styles_module_default()).geolocationButton,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                            primary: true,
                            onClick: getLocation,
                            loading: loadingGeolocation,
                            fullWidth: true,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdLocationPin */.vcr, {
                                    size: 20
                                }),
                                t("sharePosition")
                            ]
                        })
                    }),
                    shouldShowHighMap && formMap,
                    shouldRequireCity && !placeId && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Address_styles_module_default()).inputContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CitySelector/* default */.Z, {
                            city: selectedCity ? {
                                label: selectedCity,
                                value: selectedCity
                            } : null,
                            changeSelectedCity: function(option) {
                                if (!option) return clear(models/* ClearType.SELECTED_CITY */.Nl.SELECTED_CITY);
                                clear(models/* ClearType.PLACE_ID */.Nl.PLACE_ID);
                                setSelectedCity(option.value);
                            }
                        })
                    }),
                    (!shouldRequireCity || selectedCity || placeId) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Address_styles_module_default()).inputContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressSearchSelector, {
                                value: placeId,
                                onChange: function(value) {
                                    setShowSubmitButton(true);
                                    setPlaceId(value);
                                },
                                passProps: {
                                    setPlaceId: setPlaceId
                                },
                                isModal: isModal
                            }),
                            !loading && (displayOutOfBoundsMsg || placeId && !location1) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OutOfBoundsAlert/* default */.Z, {
                                message: displayOutOfBoundsMsg || "No llegamos a esa direcci\xf3n"
                            }) : placeId ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedStore/* default */.Z, {
                                preferences: preferences
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Address_styles_module_default()).example_label,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("address.example")
                                })
                            })
                        ]
                    }),
                    (!shouldRequireCity || placeId) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Address_styles_module_default()).inputContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondLineInput, {
                            value: addressLine2,
                            onChange: function(value) {
                                setShowSubmitButton(true);
                                setAddressLine2(value);
                            }
                        })
                    }),
                    placeId && renderTime(),
                    shouldShowLowMap && formMap
                ]
            })
        });
    };
    if (type === models/* AddressFormType.DeliveryTypes */.tv.DeliveryTypes) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                width: 340
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryType/* default */.Z, {
                value: null,
                onChange: onSelectDeliveryType,
                light: true,
                passProps: {
                    light: true
                }
            })
        });
    }
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: containerRef,
        className: classnames_default()((Address_styles_module_default()).formContainer, (Address_styles_module_default()).container, (_obj = {}, Address_defineProperty(_obj, (Address_styles_module_default()).modalFormContainer, type === models/* AddressFormType.FormAndMap */.tv.FormAndMap), Address_defineProperty(_obj, (Address_styles_module_default()).backgroundColor, isModal), _obj)),
        children: [
            sideMap,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((Address_styles_module_default()).formSection, Address_defineProperty({}, (Address_styles_module_default()).formSectionThin, width < MOBILE_WIDTH_THRESHOLD && typeSuggestion !== models/* AddressFormType.FormAndMap */.tv.FormAndMap)),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            shouldShowTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: (Address_styles_module_default()).formTitle,
                                children: t("title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryType/* default */.Z, {
                                value: deliveryType,
                                onChange: function(value) {
                                    setShowSubmitButton(true);
                                    updateDeliveryType(value);
                                    if (value !== models/* DeliveryTypes.DELIVERY */.TB.DELIVERY && !storeId && (stores === null || stores === void 0 ? void 0 : stores.length)) {
                                        updateStoreId(stores[0].value);
                                    }
                                }
                            }),
                            deliveryType === models/* DeliveryTypes.DELIVERY */.TB.DELIVERY && renderDelivery(),
                            deliveryType !== models/* DeliveryTypes.DELIVERY */.TB.DELIVERY && renderStore(),
                            deliveryType !== models/* DeliveryTypes.DELIVERY */.TB.DELIVERY && renderTime(),
                            deliveryType !== models/* DeliveryTypes.DELIVERY */.TB.DELIVERY && renderTableName(),
                            (placeId || storeId) && /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreName/* default */.Z, {
                                preferences: preferences,
                                website: {
                                    showStoreName: showStoreName
                                },
                                isOnMenu: true
                            })
                        ]
                    }),
                    showSubmitButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(SubmitButton, {
                        disabled: isSubmitDisabled,
                        message: deliveryType === models/* DeliveryTypes.DELIVERY */.TB.DELIVERY ? t("useAddress") : t("useStore"),
                        onClick: function() {
                            (0,posthog.sendPosthogData)(posthog.EVENTS.clicked.addressSubmitButton);
                            setShowSubmitButton(false);
                            closeModal();
                            showMessage("Direcci\xf3n guardada");
                        }
                    })
                ]
            })
        ]
    });
};
function CreateAddress(param) {
    var closeModal = param.closeModal;
    var websiteId = (0,useWebsiteId/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            close: closeModal,
            customClass: (Address_styles_module_default()).modal,
            avoidElementsClass: "submodal",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Address_styles_module_default()).closeIconSection,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Address_styles_module_default()).closeIconContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Address_styles_module_default()).closeIcon,
                            onClick: closeModal,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdClose */.FU5, {
                                size: 30
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientSuspense/* default */.Z, {
                    fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Address_styles_module_default()).modalLoading,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {})
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressForm, {
                        websiteId: websiteId,
                        closeModal: closeModal,
                        type: models/* AddressFormType.FormAndMap */.tv.FormAndMap,
                        isModal: true
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 19060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SsgFallback; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_Loading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69528);
/* harmony import */ var _packages_justo_parts_lib_components_Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59848);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80805);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_4__);





function SsgFallback() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_packages_justo_parts_lib_components_Container__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().container),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Loading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().loading)
        })
    });
};


/***/ }),

/***/ 1555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src600186761_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src600186761_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src600186761_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useIsDarkMode__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54731);
/* harmony import */ var _hooks_useKeyboardEvent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1626);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _loadingIndicators_Spinner__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18899);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}








function Button(props, ref) {
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loadingState = _$ref[0], setLoading = _$ref[1];
    var buttonRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var loading = props.loading || loadingState;
    var _$ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), confirm = _$ref1[0], setConfirm = _$ref1[1];
    var overrideOnClickRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var darkMode = (0,_hooks_useIsDarkMode__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var onClick = function() {
        var _ref = _asyncToGenerator(_codebuild_output_src600186761_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _codebuild_output_src600186761_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(props.disabled || loading)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        if (!props.confirmText) {
                            _ctx.next = 9;
                            break;
                        }
                        if (!confirm) {
                            _ctx.next = 7;
                            break;
                        }
                        {
                            setConfirm(false);
                        }
                        _ctx.next = 9;
                        break;
                    case 7:
                        setConfirm(true);
                        return _ctx.abrupt("return");
                    case 9:
                        setLoading(true);
                        if (!overrideOnClickRef.current) {
                            _ctx.next = 15;
                            break;
                        }
                        _ctx.next = 13;
                        return overrideOnClickRef.current();
                    case 13:
                        _ctx.next = 21;
                        break;
                    case 15:
                        if (!props.onClick) {
                            _ctx.next = 20;
                            break;
                        }
                        _ctx.next = 18;
                        return props.onClick();
                    case 18:
                        _ctx.next = 21;
                        break;
                    case 20:
                        if (props.to) {
                            router.push(props.to);
                        }
                    case 21:
                        // check if button is mounted
                        if (buttonRef.current) {
                            setLoading(false);
                        }
                    case 22:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var setOnClick = function(onClick) {
        overrideOnClickRef.current = onClick;
    };
    var _clickOnKey;
    (0,_hooks_useKeyboardEvent__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((_clickOnKey = props.clickOnKey) !== null && _clickOnKey !== void 0 ? _clickOnKey : "none", function() {
        if (!props.disabled && !loading && props.clickOnKey) {
            onClick();
        }
    });
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useImperativeHandle)(ref, function() {
        return {
            onClick: onClick,
            setOnClick: setOnClick,
            click: onClick,
            focus: function() {
                if (buttonRef.current) {
                    buttonRef.current.focus();
                }
            }
        };
    });
    var style = props.disabled ? "disabled" : props.primary ? "primary" : props.danger ? "danger" : props.contrast ? "contrast" : "default";
    var size = props.small ? "small" : props.extraBig ? "extraBig" : props.big ? "big" : "default";
    var className = classnames__WEBPACK_IMPORTED_MODULE_5___default()({
        "inline-flex justify-center items-center shadow-sm rounded": true,
        "font-semibold": true,
        "transition ease-in-out duration-150": true,
        "focus:outline-none focus:ring-2 focus:ring-offset-2": true,
        "px-4 py-2 text-sm": size === "default",
        "px-4 py-1 text-sm": size === "small",
        "px-5 py-3 text-md": size === "big",
        "px-5 py-4 text-md": size === "extraBig",
        "cursor-not-allowed": props.disabled,
        "w-full": props.full,
        "!border-gray-100 text-gray-400": style === "disabled",
        "border-gray-100 text-gray-700": style === "default",
        "text-white": style === "primary" || style === "danger",
        "focus:ring-gray-300": style === "default",
        "focus:button-v3-primary": style === "primary",
        "focus:ring-red-500": style === "danger",
        "bg-gray-100 border-gray-100": style === "disabled" || style === "default",
        "bg-red-500 border-red-500": style === "danger",
        "button-v3-primary": style === "primary",
        "bg-gray-480 border-gray-480 text-white": style === "contrast" && !darkMode,
        "bg-white border-white text-gray-480": style === "contrast" && darkMode,
        "hover:bg-gray-200": !loading && style === "default" || style === "contrast" && darkMode && !loading,
        "hover:button-v3-primary": !loading && style === "primary",
        "hover:bg-red-400": !loading && style === "danger",
        "hover:bg-gray-350": style === "contrast" && !darkMode && !loading
    }, props.className);
    var _type;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
        ref: buttonRef,
        type: (_type = props.type) !== null && _type !== void 0 ? _type : "submit",
        form: "formId",
        disabled: props.disabled || loading,
        onClick: onClick,
        className: className,
        children: [
            !loading && props.icon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(props.icon, {
                className: "-ml-0.5 mr-2 w-4",
                "aria-hidden": "true"
            }) : null,
            loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_loadingIndicators_Spinner__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                className: "mr-3",
                color: style === "default" ? "gray" : "white"
            }) : null,
            confirm ? props.confirmText : props.children
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(Button));


/***/ }),

/***/ 18899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SpinnerLoading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


function SpinnerLoading(props) {
    var color = props.color || "gray";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(props.className, {
            "h-5 w-5": !props.size || props.size === "sm",
            "h-4 w-4": props.size === "xs",
            "h-6 w-6": props.size === "md",
            "h-8 w-8": props.size === "lg",
            "h-10 w-10": props.size === "xl",
            "animate-spin": true,
            "text-white": color === "white",
            "text-gray-500": color === "gray",
            "text-blue-500": color === "blue" || color === "primary",
            "text-green-500": color === "green",
            "text-red-500": color === "red",
            "text-yellow-500": color === "yellow",
            "text-black": color === "black"
        }),
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                className: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                strokeWidth: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            })
        ]
    });
};


/***/ }),

/***/ 55515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ useMyOrderPreferences; }
/* harmony export */ });
/* unused harmony export getMyOrderPreferencesQuery */
/* harmony import */ var _data_fragments_preferences_appOrderPreferences__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82339);
/* harmony import */ var _data_fragments_preferences_storePreferencesFragment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54654);
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90257);
/* harmony import */ var _packages_apollo_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25074);
/* harmony import */ var _packages_apollo_hooks__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_packages_apollo_hooks__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50456);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  query getMyOrderPreferences($websiteId: ID) {\n    preferences: userPreferences(websiteId: $websiteId) {\n      ...appOrderPreferences\n      storeWithSlots: store {\n        ...storePreferences\n        schedule {\n          itsOpenNow: itsAvailableAt(websiteId: $websiteId, shouldAddMessage: true)\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var getMyOrderPreferencesQuery = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_3__["default"])(_templateObject(), _data_fragments_preferences_appOrderPreferences__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, _data_fragments_preferences_storePreferencesFragment__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
var useMyOrderPreferences = function(websiteId) {
    return (0,_packages_apollo_hooks__WEBPACK_IMPORTED_MODULE_2__.useApolloQuery)({
        query: getMyOrderPreferencesQuery,
        variables: {
            websiteId: websiteId
        },
        omit: (0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)() || !websiteId,
        partial: true
    });
};


/***/ }),

/***/ 86288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMyOrderPreferencesWithDefault; }
/* harmony export */ });
/* harmony import */ var _data_queries_preferences_getMyOrderPreferences__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55515);

/**
 * NOTE: This must be SSR Compatible (i.e. it must not suspend nor return user data)
 */ function useMyOrderPreferencesWithDefault(website) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        queryStoreAvailabilityFromSlots: true
    };
    var ref = (0,_data_queries_preferences_getMyOrderPreferences__WEBPACK_IMPORTED_MODULE_0__/* .useMyOrderPreferences */ .n)(website._id), queriedPrefs = ref.preferences, networkStatus = ref.networkStatus;
    var preferences = queriedPrefs ? queriedPrefs : {
        menuId: website.defaultMenuId
    };
    return {
        preferences: preferences,
        loading: networkStatus <= 2 || !website
    };
};


/***/ }),

/***/ 53630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ react__WEBPACK_IMPORTED_MODULE_0__.useRef; },
/* harmony export */   "s": function() { return /* reexport safe */ react__WEBPACK_IMPORTED_MODULE_0__.useRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




/***/ }),

/***/ 47592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useSharedPageRewriteHelper; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helpers_misc_getQueryObject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62280);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



/**
 * When using a shared page for different routes (e.g. /order and /order/productId/productName),
 * we need to force the param (productId) into the router query object.
 * Unfortunatelly, when doing a rewrite in the middleware, the passed query vars are not available.
 * @param resourceKey the key to force onto the router (e.g. 'productId')
 * @param getResourceFromUrlFn a fn that parses the current path and returns the resource value (e.g. getProductIdFromUrl)
 * @returns the router
 */ function useSharedPageRewriteHelper(resourceKey, getResourceFromUrlFn) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        // We use useEffect so that the cached SSR version does not render the resource. It should render the wrapper instead.
        var matchedResource = getResourceFromUrlFn(router.asPath);
        if (router.isReady && matchedResource && router.query[resourceKey] !== matchedResource) {
            var query = (0,_helpers_misc_getQueryObject__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(router);
            router.replace({
                pathname: window.location.pathname,
                query: _objectSpread({}, query, _defineProperty({}, resourceKey, matchedResource))
            });
        }
    }, [
        router,
        resourceKey,
        getResourceFromUrlFn
    ]);
    return router;
};


/***/ }),

/***/ 25932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useTrack; }
/* harmony export */ });
/* harmony import */ var _codebuild_output_src600186761_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src600186761_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src600186761_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _packages_apollo_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25074);
/* harmony import */ var _packages_apollo_hooks__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_packages_apollo_hooks__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50456);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n          mutation trackAction(\n            $type: String\n            $productId: ID\n            $orderId: ID\n            $path: String\n            $meta: JSON\n          ) {\n            trackAction(\n              type: $type\n              productId: $productId\n              orderId: $orderId\n              path: $path\n              meta: $meta\n            )\n          }\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


function useTrack() {
    var mutate = (0,_packages_apollo_hooks__WEBPACK_IMPORTED_MODULE_1__.useMutate)();
    var track = function() {
        var _ref = _asyncToGenerator(_codebuild_output_src600186761_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(type, params) {
            return _codebuild_output_src600186761_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return mutate({
                            mutation: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_2__["default"])(_templateObject()),
                            variables: _objectSpread({}, params, {
                                type: type
                            })
                        });
                    case 3:
                        _ctx.next = 7;
                        break;
                    case 5:
                        _ctx.prev = 5;
                        _ctx.t0 = _ctx["catch"](0);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    5
                ]
            ]);
        }));
        return function track(type, params) {
            return _ref.apply(this, arguments);
        };
    }();
    return track;
};


/***/ }),

/***/ 9177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ DEFAULT_DESKTOP_WIDTH; },
/* harmony export */   "ZP": function() { return /* binding */ useWidth; }
/* harmony export */ });
/* unused harmony export DEFAULT_MOBILE_WIDTH */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90257);
/* harmony import */ var _providers_MobileOrDesktopContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95078);




var DEFAULT_DESKTOP_WIDTH = 1920;
var DEFAULT_MOBILE_WIDTH = 360;
function useWidth() {
    var ssrMobileOrDesktop = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_providers_MobileOrDesktopContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
    var ssrWidth = ssrMobileOrDesktop === "mobile" ? DEFAULT_MOBILE_WIDTH : DEFAULT_DESKTOP_WIDTH;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)() ? ssrWidth : window.innerWidth), width = ref[0], setWidth = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handler = function handler() {
            setWidth(window.innerWidth);
        };
        window.addEventListener("resize", handler);
        return function() {
            window.removeEventListener("resize", handler);
        };
    }, []);
    return width !== null && width !== void 0 ? width : ssrWidth;
};


/***/ }),

/***/ 23023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Example; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5434);
/* harmony import */ var _components_V3_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1555);



function Example() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "min-h-full bg-white px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mx-auto max-w-max",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                    className: "sm:flex",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-4xl font-bold tracking-tight text-indigo-600 sm:text-5xl",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_2__/* .MdWifiOff */ .Em6, {})
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "sm:ml-6",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "sm:border-l sm:border-gray-200 sm:pl-6",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                            className: "text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl",
                                            children: "Este sitio esta desactivado"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-1 text-base text-gray-500",
                                            children: "Para activarlo, contacta a cobranza@getjusto.com"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mt-10 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_V3_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                        primary: true,
                                        onClick: function() {
                                            return window.location.href = "https://getjusto.com";
                                        },
                                        children: "Ir a Justo"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};


/***/ }),

/***/ 25442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ NoWebsite; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43469);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_2__);



function NoWebsite(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().container),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "/images/no-website.svg",
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().image)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().title),
                children: "Este sitio web no est\xe1 configurado correctamente"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    href: "https://getjusto.com",
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().logo),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "/logo-dark.svg"
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 31143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LoadingProducts; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35611);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_2__);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}



var _Component;
var LoadingProducts = /*#__PURE__*/ function(_superClass) {
    "use strict";
    _inherits(LoadingProducts, _superClass);
    var _super = _createSuper(LoadingProducts);
    function LoadingProducts() {
        _classCallCheck(this, LoadingProducts);
        return _super.apply(this, arguments);
    }
    var _proto = LoadingProducts.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().container),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().category),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().name)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-xs-12 col-md-6",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().product)
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-xs-12 col-md-6",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().product)
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-xs-12 col-md-6",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().product)
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-xs-12 col-md-6",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().product)
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().category),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().name)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-xs-12 col-md-6",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().product)
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-xs-12 col-md-6",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().product)
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    return LoadingProducts;
}(_Component = react__WEBPACK_IMPORTED_MODULE_1__.Component);
LoadingProducts.propTypes = {};



/***/ }),

/***/ 88641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useLayout; }
/* harmony export */ });
/* harmony import */ var _hooks_useWidth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9177);

function useLayout(website) {
    var width = (0,_hooks_useWidth__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)();
    var isMobile = width < 768;
    if (website && website.menuLayout === "categories") return "categories";
    if (isMobile) return "mobile";
    if (!website) return "v2";
    if (!website.menuLayout) return "v2";
    return website.menuLayout;
};


/***/ }),

/***/ 29968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ OrderPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/SsgFallback/index.tsx
var SsgFallback = __webpack_require__(19060);
// EXTERNAL MODULE: ./node_modules/next/server.js
var server = __webpack_require__(97385);
;// CONCATENATED MODULE: ./src/helpers/middleware/sharedPages/product.ts


var getProductIdFromOrderUrl = function(pathname) {
    var match = pathname.match(/^\/(order|pedir)\/([^\/\?]+)\/?([^\/]*)/);
    if (!match) return null;
    if (match[2] === "category") return null;
    return match[2];
};
var rewriteProduct = function(url, pathname, mobileOrDesktop, hostname) {
    var productId = getProductIdFromOrderUrl(pathname);
    if (productId) {
        url.pathname = "".concat(getTenantPath(mobileOrDesktop, hostname), "/order");
        url.searchParams.set("productId", productId);
        return NextResponse.rewrite(url);
    }
    return null;
};

// EXTERNAL MODULE: ./src/hooks/useSharedPageRewriteHelper.ts
var useSharedPageRewriteHelper = __webpack_require__(47592);
// EXTERNAL MODULE: ./src/page-components/DeactivatedByDebt/index.tsx
var DeactivatedByDebt = __webpack_require__(23023);
// EXTERNAL MODULE: ./src/page-components/Layout/AbstractLayout.tsx + 28 modules
var AbstractLayout = __webpack_require__(97165);
// EXTERNAL MODULE: ./src/page-components/Layout/Website/index.tsx + 22 modules
var Website = __webpack_require__(77880);
// EXTERNAL MODULE: ./src/page-components/NoWebsite/index.tsx
var NoWebsite = __webpack_require__(25442);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Address/index.tsx + 7 modules
var Address = __webpack_require__(93154);
// EXTERNAL MODULE: ./src/hooks/useMyOrderPreferencesWithDefault.ts
var useMyOrderPreferencesWithDefault = __webpack_require__(86288);
// EXTERNAL MODULE: ./src/hooks/useSessionStorageState.ts
var useSessionStorageState = __webpack_require__(11612);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/Container/index.js
var Container = __webpack_require__(59848);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Loading/index.tsx
var Loading = __webpack_require__(31143);
// EXTERNAL MODULE: ./src/hooks/useTrack.ts
var useTrack = __webpack_require__(25932);
;// CONCATENATED MODULE: ./src/page-components/Order/Track.ts


function Track() {
    var track = (0,useTrack/* default */.Z)();
    (0,react.useEffect)(function() {
        track("viewMenu");
    }, []) // Only on mount
    ;
    return null;
};

// EXTERNAL MODULE: ./src/page-components/Order/useLayout.ts
var useLayout = __webpack_require__(88641);
;// CONCATENATED MODULE: ./src/page-components/Order/useProductsLayout.ts
function useProductsLayout(website) {
    if (!website) return "long";
    return website.productsLayout || "long";
};

// EXTERNAL MODULE: ./src/page-components/Order/styles.module.css
var styles_module = __webpack_require__(43872);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}













var OnTableModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5295).then(__webpack_require__.bind(__webpack_require__, 15295));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(15295)
            ];
        }
    },
    ssr: false
});
var PageMeta = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8264).then(__webpack_require__.bind(__webpack_require__, 98264));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(98264)
            ];
        }
    },
    ssr: false
});
var Page = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7907).then(__webpack_require__.bind(__webpack_require__, 57907));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57907)
            ];
        }
    },
    ssr: false
});
var Cart = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8761), __webpack_require__.e(615), __webpack_require__.e(3596), __webpack_require__.e(602), __webpack_require__.e(1038), __webpack_require__.e(8316), __webpack_require__.e(8106), __webpack_require__.e(3089), __webpack_require__.e(8957), __webpack_require__.e(5415)]).then(__webpack_require__.bind(__webpack_require__, 86259));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(86259)
            ];
        }
    }
});
var CartMenuV2 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8761), __webpack_require__.e(615), __webpack_require__.e(3596), __webpack_require__.e(602), __webpack_require__.e(1038), __webpack_require__.e(8316), __webpack_require__.e(8106), __webpack_require__.e(3089), __webpack_require__.e(8957), __webpack_require__.e(8581), __webpack_require__.e(6392)]).then(__webpack_require__.bind(__webpack_require__, 98581));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(98581)
            ];
        }
    }
});
var CategoriesLayout = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8761), __webpack_require__.e(615), __webpack_require__.e(3596), __webpack_require__.e(602), __webpack_require__.e(1038), __webpack_require__.e(5116), __webpack_require__.e(132)]).then(__webpack_require__.bind(__webpack_require__, 94214));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94214)
            ];
        }
    }
});
var NextOpenDate = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9230).then(__webpack_require__.bind(__webpack_require__, 79230));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79230)
            ];
        }
    }
});
var NoMenu = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3859).then(__webpack_require__.bind(__webpack_require__, 83859));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83859)
            ];
        }
    }
});
var Options = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7744).then(__webpack_require__.bind(__webpack_require__, 97744));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97744)
            ];
        }
    }
});
var Products = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8761), __webpack_require__.e(615), __webpack_require__.e(3596), __webpack_require__.e(81), __webpack_require__.e(602), __webpack_require__.e(1038), __webpack_require__.e(5116), __webpack_require__.e(8980)]).then(__webpack_require__.bind(__webpack_require__, 16677));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16677)
            ];
        }
    }
});
function Order(props) {
    var website = props.website, design = props.design, productId = props.productId, categories = props.categories, page = props.page, componentIdToSsrProps = props.componentIdToSsrProps;
    var ref = (0,useMyOrderPreferencesWithDefault/* default */.Z)(website), queryPreferences = ref.preferences, loading = ref.loading;
    var ref1 = _slicedToArray((0,useSessionStorageState/* default */.Z)("onTable"), 1), onTable = ref1[0];
    var preferences = queryPreferences ? _objectSpread({}, queryPreferences, {
        store: queryPreferences.storeWithSlots
    }) : null;
    var layout = (0,useLayout/* default */.Z)(website);
    var productCardDesign = design === null || design === void 0 ? void 0 : design.design.productCardDesign;
    var productsLayout = useProductsLayout(website);
    var router = (0,next_router.useRouter)();
    var addressModal = router.query.addressModal;
    var ref2 = (0,react.useState)(!!addressModal), modalOpen = ref2[0], setModalOpen = ref2[1];
    if (!preferences) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (styles_module_default()).loadingContainer,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {})
            })
        });
    }
    var menuId = preferences.menuId;
    if (!menuId) return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoMenu, {});
    if (!website.deliveryTypes) return null;
    if (!website.deliveryTypes.length) return null;
    var nextOpenDate = /*#__PURE__*/ (0,jsx_runtime.jsx)(NextOpenDate, {
        store: preferences.store
    });
    var products = productsLayout === "categories" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoriesLayout, _objectSpread({}, preferences, {
        website: website,
        menuId: menuId,
        // @ts-expect-error ts-migrate(2322) FIXME: Type '{ website: getWebsiteMenuInformation_cached_... Remove this comment to see the full error message
        nextOpenDate: nextOpenDate,
        preferences: preferences,
        productCardDesign: productCardDesign
    })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Products, _objectSpread({}, preferences, {
        website: website,
        productsLayout: productsLayout,
        layout: layout,
        menuId: menuId,
        loading: loading,
        nextOpenDate: nextOpenDate,
        preferences: preferences,
        productCardDesign: productCardDesign,
        preloadedCategories: categories
    }));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).container,
        children: [
            modalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(Address/* default */.Z, {
                closeModal: function() {
                    return setModalOpen(false);
                }
            }),
            onTable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OnTableModal, {}) : null,
            page ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Page, {
                pageId: page._id,
                page: page,
                componentIdToSsrProps: componentIdToSsrProps
            }) : null,
            layout === "mobile" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Cart, {
                        loading: loading,
                        website: website,
                        preferences: preferences,
                        layout: layout
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).mobileMarginTop
                    })
                ]
            }) : null,
            layout === "v2" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CartMenuV2, {
                loading: loading,
                website: website,
                preferences: preferences,
                layout: layout
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                children: [
                    preferences.store && layout !== "v2" ? nextOpenDate : null,
                    layout === "mobile" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Options, {
                                preferences: preferences,
                                website: website,
                                layout: layout
                            }),
                            products
                        ]
                    }) : null,
                    layout === "v1" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-xs-12 col-sm-6 col-md-4 last-sm",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Options, {
                                        preferences: preferences,
                                        website: website,
                                        layout: layout
                                    }),
                                    layout === "mobile" ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(Cart, {
                                        loading: loading,
                                        website: website,
                                        preferences: preferences,
                                        layout: layout
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-xs-12 col-sm-6 col-md-8",
                                children: products
                            })
                        ]
                    }) : null
                ]
            }),
            layout === "v2" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: products
            }) : null,
            productId ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta, {
                website: website
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Track, {})
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/_sites/[mobileOrDesktop]/[hostname]/order/index.tsx









var __N_SSG = true;
/**
 * Important note:
 * This page is shared between multiple routes (order, category, product and conversational-commerce routes).
 * To enable this magic, read src/helpers/middleware/sharedPages/index.ts
 */ function OrderPage(props) {
    var router = (0,useSharedPageRewriteHelper/* default */.Z)("productId", getProductIdFromOrderUrl);
    if (router.isFallback) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SsgFallback/* default */.Z, {});
    }
    if (!props.website) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoWebsite["default"], {});
    }
    if (props.website.isDeactivatedByDebt) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DeactivatedByDebt/* default */.Z, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AbstractLayout/* default */.Z, {
        LayoutComponent: Website["default"],
        initialData: props.initialData,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Order, {
            page: props.page,
            componentIdToSsrProps: props.componentIdToSsrProps,
            website: props.website,
            design: props.design,
            productId: Array.isArray(router.query.productId) ? router.query.productId[0] : router.query.productId
        })
    });
};


/***/ }),

/***/ 95078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/* harmony default export */ __webpack_exports__["Z"] = (react__WEBPACK_IMPORTED_MODULE_0__.createContext("desktop"));


/***/ }),

/***/ 98751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getClient; }
/* harmony export */ });
/* harmony import */ var _providers_apollo_getClients__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54599);

function getClient() {
    var clientName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "main";
    var clients = (0,_providers_apollo_getClients__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    return clients[clientName];
};


/***/ }),

/***/ 29344:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"example_label":"mFyGw6-BPyWPOvwl3ehht"};

/***/ }),

/***/ 65035:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal":"WcSjqTkX5cCwbq5Uudevg","formContainer":"_1vKpBxKdBzZvkC2GJkVtAw textColor","backgroundColor":"_3QNOHXIrNir1zfKlCAsv_g backgroundColor","modalFormContainer":"czWgFcPpP17gG3Dp2ypIL","mapSection":"_3b2jXLHXxSWBXN3tTwc4Jm","formSection":"tUco8lvuH0Pc7EsANa-tC","formSectionThin":"_18UyoeQZZkRANTA6_BS70R","formTitle":"_1pbTpWeXc4yEy3WsOwig-Y","formSubmitButton":"_14taenL1Y7jPUi594KOUIH","dragPinButtonContainer":"_2VZC0ex5xq4kRAE-BueK3n","separator":"HYqS86ExGwBY_Uj0Pen3C","separatorLine":"_2p679FoWKAkma_mdMvI6kF","separatorText":"_11w0c0r8dltKgh_MXqybfK","embeddedMapContainer":"_1TFfHXhHTL9RH2dSoAkTtS","embeddedMapContainerThin":"wnkIpzyeH6N-o2gxx6AEU","example_label":"_18zVJxAm1HoZpCM31AIsew","closeIconSection":"_1JGEdTziUJDetRNmMauDAs","closeIconContainer":"_3rfF75iddiNpqWnnlUz475","closeIcon":"_2l0lXgqHAjBEa9cBRO8kHj","modalLoading":"_2-EfXtNwvGQxvzhKupBaBQ","inputContainer":"_3z4OSDnifHhy8amjJZb6ze","container":"_1BlyEffYLRDjpnrazYOBO2"};

/***/ }),

/***/ 80805:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_2k40sP--bs7-ORleL6riGA","loading":"_2eozYEUmcZzMsjXiI6UIu6"};

/***/ }),

/***/ 43469:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3uvgfwBWaWQqFyLab9Dtip","image":"hS9SabcUKdHLsU7xUWYeA","title":"_3zsZZ1G9oclG4rKZNszc97","logo":"_1EDR5Wb9Y0TBlQji0Ya33U"};

/***/ }),

/***/ 35611:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"category":"_1xjc8aTIoKLyPRnukOtpMW","name":"_2WCjeuJvxsn_32SKsT2mXV loadingGlow","product":"ctUFjgEM2QfJ5t0kCcFjq loadingGlow"};

/***/ }),

/***/ 43872:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_2bEeEQNpv9yvXBBvEmpfOH orderMainContainer","mobileMarginTop":"_1Y1ns8DNZhwPZ5az9jD21B","loadingContainer":"_3-H9UEsWuWJy9oTqpF_DKH"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3662,160,5445,5990,6907,4053,6350,1470,191,868,3846,6802,4356,5963,791,7502,4336,6917,8449,5051,804,7165,9207,7605,3032,7880,9774,2888,179], function() { return __webpack_exec__(9695); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);